import { useState, useEffect } from 'react';

export const useSubscription = () => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadUsage = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/subscription/usage`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUsage(data);
      }
    } catch (err) {
      console.error('Failed to load usage:', err);
      setError(err.message);
    }
  };

  const checkLimit = () => {
    if (!usage) return true;
    return usage.daily_remaining > 0 && usage.monthly_remaining > 0;
  };

  const subscribe = async (tier) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/subscription/create-checkout`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tier })
      });

      if (response.ok) {
        const data = await response.json();
        // Redirect to Stripe Checkout
        window.location.href = data.url;
      } else {
        throw new Error('Failed to create checkout session');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const manageSubscription = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/subscription/portal`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        window.location.href = data.url;
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    loadUsage();
    // Reload every 5 minutes
    const interval = setInterval(loadUsage, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return {
    usage,
    loading,
    error,
    checkLimit,
    subscribe,
    manageSubscription,
    reload: loadUsage,
    updateUsage: (newUsage) => setUsage(newUsage)
  };
};